import { render, staticRenderFns } from "./enroll-02.vue?vue&type=template&id=615c5dab&scoped=true"
import script from "./enroll-02.vue?vue&type=script&lang=js"
export * from "./enroll-02.vue?vue&type=script&lang=js"
import style0 from "./enroll-02.vue?vue&type=style&index=0&id=615c5dab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c5dab",
  null
  
)

export default component.exports